import { render, staticRenderFns } from "./EmptyElement.vue?vue&type=template&id=09e7346c&scoped=true"
import script from "./EmptyElement.vue?vue&type=script&lang=ts"
export * from "./EmptyElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e7346c",
  null
  
)

export default component.exports